<template>
  <aside class="sidebar-toggle"
         :class="{ 'sidebar-toggle_open': isOpen }"
         @click="toggleOpen">

    <div class="sidebar-toggle-header">
      <i :class="`mdi ${icon} pointer sidebar-toggle-header-icon`"></i>

      <div class="sidebar-toggle-header-title">{{ title }}</div>

      <i class="mdi sidebar-toggle-header-open"
         :class="{ 'mdi-chevron-down': isOpen, 'mdi-chevron-right': !isOpen }"></i>
    </div>

    <div class="sidebar-toggle-body"
         :class="{ 'sidebar-toggle-body_open' : isOpen }">
      <slot />
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  components: {},

  computed: {},

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.sidebar-toggle {
  color: $grey-4;
  cursor: pointer;
  width: fit-content;
  padding-right: 10px;
  margin: 5px 0;

  .sidebar-toggle-header {
    display: flex;
    align-items: center;
    border-left: 5px solid white;
    padding-left: 35px;
    min-height: 42px;

    .sidebar-toggle-header-icon {
      font-size: 18px;
      margin-right: 7px;
      color: #707070;
    }

    .sidebar-toggle-header-title {
      font-size: 14px;
      user-select: none;
      width: 105px;
      flex-shrink: 0;
    }

    .sidebar-toggle-header-open {
      margin-left: 25px;
      font-size: 22px;
      display: flex;
    }
  }

  .sidebar-toggle-body {
    height: 0px;
    overflow: hidden;
    margin-left: 60px;
    border-left: 2px solid #c4c4c4;

    &.sidebar-toggle-body_open {
      height: auto;
      padding: 10px 0;
    }

    .sidebar-item {
      margin: 0 0 20px 0;

      ::v-deep .content {
        margin-left: 10px;
      }

      ::v-deep .bar {
        display: none;
      }

      &::before {
        content: "";
        width: 10px;
        border-bottom: 2px solid #c4c4c4;
      }

      &:last-child {
        margin: 0;
      }
    }
  }

  &.sidebar-toggle_open {
    background: #f8f8f8;
    border-radius: 0px 15px 15px 0px;
  }
}
</style>
